import { useEffect, useState } from 'react'

import Button from '../app/design/Button'
import Label from '../app/design/Label'
import Modal from '../app/design/Modal'
import Paragraph from '../app/design/Paragraph'
import { CurrencyField } from '../common/fields/CurrencyField'

type VerifyAccountModalProps = {
    isOpen: boolean
    onClose: () => void
    onVerify: (firstAmount: number, secondAmount: number) => void
    isProcessing?: boolean
}

export const VerifySourceModal = ({
    isOpen,
    onClose,
    onVerify,
    isProcessing = false,
}: VerifyAccountModalProps) => {
    const [firstAmount, setFirstAmount] = useState<number>(0)
    const [secondAmount, setSecondAmount] = useState<number>(0)

    useEffect(() => {
        if (!isOpen) {
            setFirstAmount(0)
            setSecondAmount(0)
        }
    }, [isOpen])

    return (
        <Modal
            size="medium"
            isOpen={isOpen}
            onClose={() => onClose()}
            title="Verify account"
            showDividers={true}
            footer={
                <div className="flex w-full items-center justify-end gap-x-4">
                    <Button intent="secondary" onClick={onClose}>
                        Cancel
                    </Button>
                    <Button
                        intent="primary"
                        onClick={() => onVerify(firstAmount, secondAmount)}
                        disabled={!(firstAmount > 0 && secondAmount > 0)}
                        isLoading={isProcessing}
                    >
                        Verify
                    </Button>
                </div>
            }
        >
            <div className="flex flex-col gap-3 py-2">
                <Paragraph className="mb-4">
                    Enter the amounts for the two small deposits that were sent to this account.
                </Paragraph>

                <Label> First amount</Label>
                <CurrencyField
                    placeholder="0.00"
                    size="medium"
                    value={firstAmount}
                    onChange={(value) => setFirstAmount(value ?? 0)}
                />
                <div className="h-3"></div>
                <Label>Second amount</Label>
                <CurrencyField
                    placeholder="0.00"
                    size="medium"
                    value={secondAmount}
                    onChange={(value) => setSecondAmount(value ?? 0)}
                />
            </div>
        </Modal>
    )
}
